<div class="map-wrapper">
    <div #mapContainer class="map-container"></div>
    <button (click)="saveView()">Save View</button>
  </div>
  